import { LOGIN, LOGOUT } from "../actionTypes";

const users = [
  { name: "bob", roles: ["customer", "admin"] },
  { name: "alice", roles: ["admin", "superadmin"] },
  { name: "charlie", roles: ["customer"] },
];


const savedUser = JSON.parse(localStorage.getItem("user")); // Rehydrate user from localStorage

const initialState = {
  user: savedUser || null, 
  isAuthenticated: !!savedUser, 
};

const authReducer = (state = initialState, action) => {
  const isUserInRole = (currentUser) => {
    const requiredRoles=['admin', 'superadmin']
    const currentUserRoles = currentUser.roles;
    const result = requiredRoles.some((role) => currentUserRoles.includes(role));
    return result;
  };
  switch (action.type) {
    case LOGIN:
      const foundUser = users.find((user) => user.name === action.payload.name.email); // Check user in the list
      if (foundUser) {
        const isUserAvailable = isUserInRole(foundUser)
        localStorage.setItem("user", JSON.stringify({...foundUser,isUserAvailable:isUserAvailable})); // Save user to localStorage
        return {
          ...state,
          user: foundUser,
          isAuthenticated: true,
          isUserAvailable:isUserAvailable
        };
      } else {
        alert("User not found or invalid credentials!"); // Notify invalid login
        return state; // Return unchanged state
      }
    case LOGOUT:
      localStorage.removeItem("user"); // Clear user from localStorage
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;
